import React, {useRef, useState} from "react";
import OtherCovenants from "./OtherCovenants";
import FinancialCovenants from "./FinancialCovenants";
import MoreInfoModal from "../../../components/MoreInfoModal";
import MoreInfoButton from "../../../UI/MoreInfoButton";
import './index.scss'

const Covenants = ({reportId, translations, data, hiddenSectionHandler, isReportSubmitted, sections} ) => {
  const sectionsRef = useRef();
    const [isOpenMoreInfo, setOpenMoreInfo] = useState(false)

    const keysToCheck = ['financial_covenants', 'loan_covenants', 'safeguards_covenants', 'environmental_covenants', 'gender_covenants', 'other_covenants'];

    const checkAnyKey = (obj, keys) => {
        return keys.some(key => key in obj);
    };

    const Header = () => {
        if (!checkAnyKey(sections, keysToCheck)) {
            return null;
        }
        return (
            <>
                <div className="editReport__sectionHeader">
                    <span  onClick={() => hiddenSectionHandler(sectionsRef)}/>
                    <h2  onClick={() => hiddenSectionHandler(sectionsRef)}>
                        {translations?.['covenants.index.headers.covenants']}
                    </h2>
                    <MoreInfoButton
                        className="editReport__sectionHeader__moreInfo"
                        onClick={()=>setOpenMoreInfo(!isOpenMoreInfo)}
                        title={translations?.['covenants.index.titles.more_info']}
                    />
                </div>
                <hr />
            </>
        )
    }


    return (
        <section className="covenants" ref={sectionsRef}>
            {isOpenMoreInfo &&
                <MoreInfoModal
                    title= {translations?.['covenants.index.headers.covenants']}
                    moreInfo={translations?.['covenants.index.more_info.more_info']}
                    close={()=>setOpenMoreInfo(false)}
                />
            }
            <Header/>
            <FinancialCovenants
                reportId={reportId}
                data={data?.financial_covenants}
                translations={translations}
                sectionId='financial_covenants'
                isReportSubmitted={isReportSubmitted}
                sections={sections}
            />
            {sections?.hasOwnProperty('financial_covenants') && <hr/>}
            <OtherCovenants
                title={translations?.['covenants.loan_covenants.headers.loan_covenants']}
                reportId={reportId}
                data={data?.loan_covenants}
                translations={translations}
                covenantsType={'loan'}
                sectionId='loan_covenants'
                isReportSubmitted={isReportSubmitted}
                sections={sections}
            />
            {sections?.hasOwnProperty('loan_covenants') && <hr/>}
            <OtherCovenants
                title={translations?.['covenants.safeguards_covenants.headers.safeguards_covenants']}
                reportId={reportId}
                data={data?.safeguards_covenants}
                translations={translations}
                covenantsType={'safeguards'}
                sectionId="safeguards_covenants"
                isReportSubmitted={isReportSubmitted}
                sections={sections}
            />
            {sections?.hasOwnProperty('safeguards_covenants') && <hr/>}
            <OtherCovenants
                title={translations?.['covenants.environmental_covenants.headers.environmental_covenants']}
                reportId={reportId}
                data={data?.environmental_covenants}
                translations={translations}
                covenantsType={'environmental'}
                sectionId="environmental_covenants"
                isReportSubmitted={isReportSubmitted}
                sections={sections}
            />
            {sections?.hasOwnProperty('environmental_covenants') && <hr/>}
            <OtherCovenants
                title={translations?.['covenants.gender_covenants.headers.gender_covenants']}
                reportId={reportId}
                data={data?.gender_covenants}
                translations={translations}
                covenantsType={'gender'}
                sectionId="gender_covenants"
                isReportSubmitted={isReportSubmitted}
                sections={sections}
            />
            {sections?.hasOwnProperty('gender_covenants') && <hr/>}
            <OtherCovenants
                title={translations?.['covenants.other_covenants.headers.other_covenants']}
                reportId={reportId}
                data={data?.other_covenants}
                translations={translations}
                covenantsType={'other'}
                sectionId="other_covenants"
                isReportSubmitted={isReportSubmitted}
                sections={sections}
            />
        </section>
    )
}

export default Covenants;
